var $e53d39a7f163580b$exports = {};
$e53d39a7f163580b$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`
};


export {$e53d39a7f163580b$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
